import React from 'react';

const Linkify: React.FC<{ children: string; external?: boolean }> = ({ children, external }) => {
  const urlPattern =
    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;

  const isUrl = (word: string) => word.match(urlPattern);

  const ensureProtocol = (url: string) => {
    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
  };

  const externalProps = external ? { target: '_blank' as const, rel: 'noopener noreferrer' } : {};

  const lines = children.split('\n');

  return (
    <span>
      {lines.map((line, lineIndex) => (
        <React.Fragment key={lineIndex}>
          {lineIndex > 0 && <br />}
          {line.split(' ').map((word, wordIndex, arr) => (
            <React.Fragment key={wordIndex}>
              {isUrl(word) ? (
                <a href={ensureProtocol(word)} {...externalProps}>
                  {word}
                </a>
              ) : (
                word
              )}
              {wordIndex < arr.length - 1 && ' '}
            </React.Fragment>
          ))}
        </React.Fragment>
      ))}
    </span>
  );
};

export default Linkify;
